<template>
	<transition
			appear
			:appear-active-class="$_inpSltMlt_styleInputSelectMultipleAnimation()">
		<v-row no-gutters>
			<v-col>
				<validation-provider
						:name="'InputSelectMultiple-' + contentKey"
						:rules="getValidationRules(contents[contentKey].rules)"
						v-slot="{ errors }">
					<v-autocomplete
							v-model="$store.state.input.data[contentKey].answer"
							
							multiple
							return-object

							:background-color="$_inpSltMlt_styleSelectMultipleBackgroundColor"
							:chips="$_inpSltMlt_styleSelectMultipleChips"
							:clearable="$_inpSltMlt_styleSelectMultipleClearable"
							:color="$_inpSltMlt_styleSelectMultipleColor"
							:deletable-chips="$_inpSltMlt_styleSelectMultipleDeletableChips"
							:dark="$_inpSltMlt_styleSelectMultipleDark"
							:dense="$_inpSltMlt_styleSelectMultipleDense"
							:filled="$_inpSltMlt_styleSelectMultipleFilled"
							:flat="$_inpSltMlt_styleSelectMultipleFlat"
							:light="$_inpSltMlt_styleSelectMultipleLight"
							:outlined="$_inpSltMlt_styleSelectMultipleOutlined"
							:small-chips="$_inpSltMlt_styleSelectMultipleSmallChips"
							:solo="$_inpSltMlt_styleSelectMultipleSolo"
							:solo-inverted="$_inpSltMlt_styleSelectMultipleSoloInverted"

							:append-icon="$_inpSltMlt_styleParamAppendIcon(contents[contentKey].params)"
							:append-outer-icon="$_inpSltMlt_styleParamAppendOuterIcon(contents[contentKey].params)"
							:prepend-icon="$_inpSltMlt_styleParamPrependIcon(contents[contentKey].params)"
							:prepend-inner-icon="$_inpSltMlt_styleParamPrependInnerIcon(contents[contentKey].params)"

							:hint="$_inpSltMlt_langParamHint(contents[contentKey].params)"
							:message="$_inpSltMlt_langParamMessage(contents[contentKey].params)"
							:placeholder="$_inpSltMlt_langParamPlaceholder(contents[contentKey].params)"
							:prefix="$_inpSltMlt_langParamPrefix(contents[contentKey].params)"
							:suffix="$_inpSltMlt_langParamSuffix(contents[contentKey].params)"

							item-avater="icon"
							item-text="text"
							item-value="key"
							:items="arrayObject(contents[contentKey].options)"

							:error-messages="errors" />
				</validation-provider>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputSelectMultiple',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// lang
			$_inpSltMlt_langParamHint() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.hint;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSltMlt_langParamMessage() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.message;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSltMlt_langParamPlaceholder() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.placeholder;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSltMlt_langParamPrefix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.prefix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			$_inpSltMlt_langParamSuffix() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					const param_ = params.suffix;
					if(self_.isFalse(param_)) { return null }
					return self_.getLangsVal(param_)
				}
			},
			// style
			$_inpSltMlt_styleInputSelectMultiple() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'inputSelectMultiple')
				}
			},
			$_inpSltMlt_styleInputSelectMultipleAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpSltMlt_styleInputSelectMultiple()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpSltMlt_styleSelectMultiple() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'selectMultiple')
			},
			$_inpSltMlt_styleSelectMultipleBackgroundColor() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.backgroundColor)
			},
			$_inpSltMlt_styleSelectMultipleChips() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.chips)
			},
			$_inpSltMlt_styleSelectMultipleClearable() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.clearable)
			},
			$_inpSltMlt_styleSelectMultipleColor() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.color)
			},
			$_inpSltMlt_styleSelectMultipleDeletableChips() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.deletableChips)
			},
			$_inpSltMlt_styleSelectMultipleDark() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dark)
			},
			$_inpSltMlt_styleSelectMultipleDense() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.dense)
			},
			$_inpSltMlt_styleSelectMultipleFilled() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.filled)
			},
			$_inpSltMlt_styleSelectMultipleFlat() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.flat)
			},
			$_inpSltMlt_styleSelectMultipleLight() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.light)
			},
			$_inpSltMlt_styleSelectMultipleOutlined() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.outlined)
			},
			$_inpSltMlt_styleSelectMultipleSmallChips() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.smallChips)
			},
			$_inpSltMlt_styleSelectMultipleSolo() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.solo)
			},
			$_inpSltMlt_styleSelectMultipleSoloInverted() {
				const self_ = this;
				const style_ = self_.$_inpSltMlt_styleSelectMultiple;
				if(self_.isFalse(style_)) { return null }
				return self_.getStylesVal(style_.soloInverted)
			},
			$_inpSltMlt_styleParamAppendIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					
					const param_ = params.appendIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpSltMlt_styleParamAppendOuterIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					
					const param_ = params.appendOuterIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpSltMlt_styleParamPrependIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					
					const param_ = params.prependIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			},
			$_inpSltMlt_styleParamPrependInnerIcon() {
				const self_ = this;
				return params => {
					if(self_.isFalse(params)) { return null }
					
					const param_ = params.prependInnerIcon;
					if(self_.isFalse(param_)) { return null }
					return self_.getStylesVal(param_)
				}
			}
		}
	}
</script>

<style scoped>
</style>
